export function stickyNotes() {
  return document.querySelectorAll<HTMLElement>(".sticky-note");
}

export function svgElementsOnBoard() {
  return document.querySelectorAll<SVGSVGElement>(".board svg, .draw-layer");
}

export function removeBoxShadows(el: HTMLElement) {
  el.setAttribute("old-box-shadow", el.style.boxShadow);
  el.style.boxShadow = "none";
}

export function resetBoxShadows(el: HTMLElement) {
  el.style.boxShadow = el.getAttribute("old-box-shadow") || "";
  el.removeAttribute("old-box-shadow");
}

// html2canvas does not resolve `currentColor` or CSS `var(...)` inside SVG
// presentation attributes, so we replace them with the browser-computed color
// for the duration of the screenshot.
export function setExplicitCurrentColor(svg: SVGSVGElement) {
  setAll("stroke");
  setAll("fill");

  function setAll(attribute: "stroke" | "fill") {
    if (needsResolving(svg.getAttribute(attribute))) {
      set(svg, attribute);
    }
    svg
      .querySelectorAll(`[${attribute}=currentColor], [${attribute}^="var("]`)
      .forEach((el) => set(el, attribute));
  }

  function needsResolving(value: string | null) {
    return value === "currentColor" || value?.startsWith("var(") === true;
  }

  function set(el: Element, attribute: "stroke" | "fill") {
    el.setAttribute(`data-screenshot-orig-${attribute}`, el.getAttribute(attribute)!);
    el.setAttribute(attribute, window.getComputedStyle(el)[attribute]);
  }
}

export function resetExplicitCurrentColor(svg: SVGSVGElement) {
  resetAll("stroke");
  resetAll("fill");

  function resetAll(attribute: "stroke" | "fill") {
    if (svg.getAttribute(`data-screenshot-orig-${attribute}`) !== null) {
      reset(svg, attribute);
    }
    svg
      .querySelectorAll(`[data-screenshot-orig-${attribute}]`)
      .forEach((el) => reset(el, attribute));
  }

  function reset(el: Element, attribute: "stroke" | "fill") {
    const original = el.getAttribute(`data-screenshot-orig-${attribute}`)!;
    el.removeAttribute(`data-screenshot-orig-${attribute}`);
    el.setAttribute(attribute, original);
  }
}

export function setExplicitSize(svg: SVGSVGElement) {
  svg.setAttribute(
    "old-values",
    JSON.stringify({
      width: svg.getAttribute("width"),
      height: svg.getAttribute("height"),
    } satisfies SavedSvgAttributes),
  );
  setAllAttributes(svg, { width: "" + svg.clientWidth, height: "" + svg.clientHeight });
}

export function resetExplicitSize(svg: SVGSVGElement) {
  const oldValues = JSON.parse(svg.getAttribute("old-values")!) as SavedSvgAttributes;
  svg.removeAttribute("old-values");
  setAllAttributes(svg, oldValues);
}

interface SavedSvgAttributes {
  width: string | null;
  height: string | null;
}

function setAllAttributes(svg: SVGSVGElement, attrs: SavedSvgAttributes) {
  setAttribute(svg, "width", attrs.width);
  setAttribute(svg, "height", attrs.height);
}

function setAttribute(svg: SVGSVGElement, name: string, value: string | null) {
  if (value) {
    svg.setAttribute(name, value);
  } else {
    svg.removeAttribute(name);
  }
}
